const flatbuffers = require('flatbuffers')
const flexbuffers = require('flatbuffers/js/flexbuffers')

const SbActualFbLib = require('../lib/js/sportsbook/actual.js')
const SbTreeFbLib = require('../lib/js/sportsbook/tree.js')

const h = require('./_help.encode')

module.exports = function encodeSbActual ({ sportEvents, sports, categories, tournaments }) {
  const fbBuilder = new flatbuffers.Builder(0)

  const encode = h.createEncoder(SbActualFbLib, fbBuilder)
  const encodeEnum = h.createEnumEncoder(SbActualFbLib)

  const encodeTree = h.createEncoder(SbTreeFbLib, fbBuilder)
  const encodeTreeEnum = h.createEnumEncoder(SbTreeFbLib)

  const mapString = new Map()
  const encodeString = h.createStringEncoder(fbBuilder, mapString)

  const encodedActual = encode('Actual', 'createActual',
    encode('Actual', 'createSportsVector', sports.map(sport =>
      encodeTree('Sport', 'createSport',
        sport.sbId,
        sport.customId,
        encodeString(sport.name),
        sport.state,
        sport.weight,
        sport.sportEventsNumber,
        sport.liveSportEventsNumber,
        encodeTreeEnum('SbType', sport.sbType),
        encodeTree('Sport', 'createMatchStatusesVector', sport.matchStatuses?.map(matchStatus =>
          encodeTree('MatchStatus', 'createMatchStatus',
            encodeString(matchStatus.description),
            matchStatus.periodNumber,
            matchStatus.state,
            encodeString(matchStatus.abbreviation),
            matchStatus.status,
          )
        ) ?? []),
      )
    )),

    encode('Actual', 'createCategoriesVector', categories.map(category =>
      encodeTree('Category', 'createCategory',
        category.sbId,
        category.customId,
        encodeString(category.name),
        category.state,
        category.weight,
        category.sbSportId,
        category.customSportId,
        encodeString(category.countryCode),
        category.sportEventsNumber,
        category.liveSportEventsNumber,
        encodeTreeEnum('SbType', category.sbType),
      )
    )),

    encode('Actual', 'createTournamentsVector', tournaments.map(tournament =>
      encodeTree('Tournament', 'createTournament',
        tournament.sbId,
        tournament.customId,
        encodeString(tournament.name),
        tournament.state,
        tournament.weight,
        tournament.sbCategoryId,
        tournament.customCategoryId,
        encodeString(tournament.image),
        tournament.sportEventsNumber,
        tournament.liveSportEventsNumber,
        tournament.top,
        encodeTreeEnum('SbType', tournament.sbType),
      )
    )),

    encode('Actual', 'createSportEventsVector', sportEvents.map(sportEvent =>
      encode('SportEvent', 'createSportEvent',
        sportEvent.id,
        encodeEnum('SportEventType', sportEvent.type),
        sportEvent.provider,
        encodeEnum('SportEventSeType', sportEvent.se_type),
        encodeEnum('SportEventLiveOdds', sportEvent.liveodds),
        sportEvent.state,
        sportEvent.status,
        sportEvent.weight,
        sportEvent.sport_id,
        sportEvent.category_id,
        sportEvent.tournament_id,
        BigInt(sportEvent.scheduled),
        BigInt(sportEvent.timestamp),
        sportEvent.activeMarketsCount,

        encode('SportEvent', 'createCompetitorsVector', sportEvent.competitors.map(competitor =>
          encode('Competitor', 'createCompetitor',
            competitor.id,
            encodeString(competitor.name),
            competitor.state,
            encodeEnum('CompetitorQualifier', competitor.qualifier),
            encodeString(competitor.abbreviation),
            encodeString(competitor.country_code),
            encodeString(competitor.img?.small),
            encodeString(competitor.img?.medium),
            encodeString(competitor.img?.big),
          ))
        ),

        encode('SportEvent', 'createMarketsVector', sportEvent.markets.map(market =>
          encode('Market', 'createMarket',
            market.id,
            encodeString(market.specifiers),
            market.status,
            market.state,
            market.weight,
            market.provider,
            market.favourite,
            encode('Market', 'createOutcomesVector', market.outcomes.map(outcome =>
              encode('Outcome', 'createOutcome',
                outcome.id,
                Math.round(outcome.odds * 100),
                outcome.state,
                outcome.active,
                encodeEnum('OutcomeType', outcome.type),
                outcome.team,
              ))
            ),
            BigInt(market.timestamp),
            encodeString(market.extended_specifiers),
          ))
        ),

        (() => {
          if (sportEvent.match?.timestamp) {
            // Workaround not to deal with bigints flexbuffers
            sportEvent.match.timestamp = String(sportEvent.match.timestamp)
          }

          return encode('SportEvent', 'createMatchVector', flexbuffers.encode(sportEvent.match))
        })(),

        encodeString(sportEvent.tournament_round_type),
        encodeString(sportEvent.tournament_round_level),
        sportEvent.tournament_round_number,

        encodeString(sportEvent.video),
        sportEvent.stats,
        sportEvent.dicePlatformId,
        encode('SportEvent', 'createPerformVector', sportEvent.perform?.map(p =>
          encode('Perform', 'createPerform',
            encodeString(p.type),
            encodeString(p.assetId),
            encodeString(p.fixtureId),
            encodeString(p.allowedCountryCodes),
          )
        ) ?? []),

        sportEvent.t_settings?.type,
        encode('SportEvent', 'createTSettingsListVector', sportEvent.t_settings?.list_t ?? []),

        encode('SportEvent', 'createTagsVector', sportEvent.tags?.map(tag => encodeString(tag)) ?? []),

        encodeString(sportEvent.igame?.eventId),
        encode('SportEvent', 'createIGameStreamsVector', sportEvent.igame?.streams?.map(stream =>
          encode('IGameStream', 'createIGameStream',
            stream.controls,
            stream.fixedSize,
            stream.fullscreen,
            encodeString(stream.streamType),
            encodeString(stream.description),
            stream.playerWidth,
            stream.streamWidth,
            stream.playerHeight,
            stream.streamHeight,
            encodeString(stream.geoCountryAllow),
            encodeString(stream.geoCountryBlock),
            stream.audioBitRateKbps,
            encodeString(stream.streamStretching),
            encodeString(stream.uniqueStreamName),
            stream.videoBitRateKbps,
          )
        ) ?? []),

        encodeString(sportEvent.extra?.['product_info']?.['is_in_hosted_statistics']),
        encodeString(sportEvent.extra?.['product_info']?.['is_in_live_score']),
        encodeString(sportEvent.extra?.['product_info']?.['is_in_live_match_tracker']),
        encodeString(sportEvent.extra?.['product_info']?.['links']?.['link']?.['name']),
        encodeString(sportEvent.extra?.['product_info']?.['links']?.['link']?.['ref']),
        encodeEnum('SportEventTopType', sportEvent.topEventType),
        sportEvent.custom_sport_id,
        sportEvent.custom_category_id,
        sportEvent.custom_tournament_id,

        encodeString(sportEvent.avbetradar?.id),
        encode('SportEvent', 'createAvbetradarStreamsVector', sportEvent.avbetradar?.streams?.map?.(stream =>
          encode('AvbetradarStream', 'createAvbetradarStream',
            encodeString(stream.id),
            encodeString(stream.product?.id),
            encodeString(stream.product?.name),
            encodeString(stream.startTime),
            encodeString(stream.stream_status?.id),
            encodeString(stream.stream_status?.name),
          )
        ) ?? []),

        encodeString(sportEvent.sportlevel),
        encodeString(sportEvent.bigsports),
      ))
    ),
  )

  fbBuilder.finish(encodedActual)

  const binaryActual = fbBuilder.asUint8Array()

  return binaryActual
}
